// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS ProgramDetails INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty, get } from 'lodash';
import { Card, CardHeader, CardText, Divider, MoreOrLess } from '@unite-us/ui';
import { IntlProvider } from 'react-intl';
import Locations from "../locations/Locations";
import ServiceAreas from "../ServiceAreas";
import ProgramAcceptance from "./ProgramAcceptance";
import ProgramDescription from "./ProgramDescription";
import ProgramEligibility from "./ProgramEligibility";
import ProgramUsersInfo from "./ProgramUsersInfo";

/**
 * @visibleName ProgramDetailsV2 DEPRECATED
*/

var ProgramDetailsV2 = function ProgramDetailsV2(props) {
  var className = props.className,
    clickableAddress = props.clickableAddress,
    feeScheduleProgramIconDetails = props.feeScheduleProgramIconDetails,
    initiallyCollapsed = props.initiallyCollapsed,
    isFeeScheduleProgram = props.isFeeScheduleProgram,
    openLink = props.openLink,
    originLatLng = props.originLatLng,
    _props$program = props.program,
    locations = _props$program.locations,
    service_areas = _props$program.service_areas,
    name = _props$program.name,
    receiving_referrals = _props$program.receiving_referrals,
    status = _props$program.status,
    program = props.program,
    rightHeaderComponent = props.rightHeaderComponent,
    showProgramUsersInfo = props.showProgramUsersInfo,
    intlProvider = props.intlProvider,
    showReferralStatus = props.showReferralStatus;
  var RightHeaderComponent = rightHeaderComponent;
  var serviceAreas = !isEmpty(service_areas) && /*#__PURE__*/React.createElement(ServiceAreas, {
    className: "program-details__section",
    service_areas: service_areas,
    intlProvider: intlProvider
  });
  return /*#__PURE__*/React.createElement(IntlProvider, {
    defaultLocale: "en",
    locale: intlProvider.locale,
    messages: intlProvider.messages
  }, /*#__PURE__*/React.createElement(Card, {
    className: classNames('program-details', className)
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "program-details__header ".concat(className),
    headerIconDetails: feeScheduleProgramIconDetails,
    showHeaderIcon: isFeeScheduleProgram,
    title: name,
    subtitle: get(program, 'name_untranslated', '')
  }, showReferralStatus && /*#__PURE__*/React.createElement(ProgramAcceptance, {
    receiving_referrals: receiving_referrals,
    status: status
  }), rightHeaderComponent && /*#__PURE__*/React.createElement(RightHeaderComponent, null)), /*#__PURE__*/React.createElement(CardText, null, initiallyCollapsed ? /*#__PURE__*/React.createElement(MoreOrLess, null, /*#__PURE__*/React.createElement(ProgramUsersInfo, {
    program: program,
    showProgramUsersInfo: showProgramUsersInfo
  }), /*#__PURE__*/React.createElement(ProgramDescription, {
    className: "program-details__section",
    openLink: openLink,
    program: program
  }), !isEmpty(locations) && /*#__PURE__*/React.createElement(Divider, {
    className: "program-details__divider"
  }), /*#__PURE__*/React.createElement(Locations, {
    className: "program-details__section",
    clickableAddress: clickableAddress,
    locations: locations,
    originLatLng: originLatLng,
    intlProvider: intlProvider
  }), (!isEmpty(locations) || !isEmpty(service_areas)) && /*#__PURE__*/React.createElement(Divider, {
    className: "program-details__divider"
  }), serviceAreas, !isEmpty(service_areas) && /*#__PURE__*/React.createElement(Divider, {
    className: "program-details__divider"
  }), /*#__PURE__*/React.createElement(ProgramEligibility, {
    className: "program-details__section",
    program: program
  })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProgramUsersInfo, {
    program: program,
    showProgramUsersInfo: showProgramUsersInfo
  }), /*#__PURE__*/React.createElement(ProgramDescription, {
    className: "program-details__section",
    openLink: openLink,
    program: program,
    showMore: true
  }), !isEmpty(locations) && /*#__PURE__*/React.createElement(Divider, {
    className: "program-details__divider"
  }), /*#__PURE__*/React.createElement(Locations, {
    className: "program-details__section",
    clickableAddress: clickableAddress,
    locations: locations,
    originLatLng: originLatLng,
    intlProvider: intlProvider,
    showMore: true
  }), (!isEmpty(locations) || !isEmpty(service_areas)) && /*#__PURE__*/React.createElement(Divider, {
    className: "program-details__divider"
  }), serviceAreas, !isEmpty(service_areas) && /*#__PURE__*/React.createElement(Divider, {
    className: "program-details__divider"
  }), /*#__PURE__*/React.createElement(ProgramEligibility, {
    className: "program-details__section",
    program: program,
    showMore: true
  })))));
};
ProgramDetailsV2.propTypes = {
  className: PropTypes.string,
  clickableAddress: PropTypes.bool,
  initiallyCollapsed: PropTypes.bool,
  openLink: PropTypes.func,
  originLatLng: PropTypes.array,
  isFeeScheduleProgram: PropTypes.bool,
  feeScheduleProgramIconDetails: PropTypes.object,
  program: PropTypes.shape({
    name: PropTypes.string,
    receiving_referrals: PropTypes.bool,
    status: PropTypes.string,
    locations: PropTypes.array,
    service_areas: PropTypes.array,
    eligibility_text: PropTypes.string
  }).isRequired,
  /**
   * Property to pass a component that will render in the header.
   * This feature is used to render an edit program link in the upper right.
   */
  rightHeaderComponent: PropTypes.func,
  showProgramUsersInfo: PropTypes.bool,
  intlProvider: PropTypes.shape({
    locale: PropTypes.string,
    messages: PropTypes.array
  }),
  showReferralStatus: PropTypes.bool
};
ProgramDetailsV2.defaultProps = {
  className: '',
  clickableAddress: false,
  feeScheduleProgramIconDetails: {},
  initiallyCollapsed: true,
  isFeeScheduleProgram: false,
  openLink: typeof window !== 'undefined' ? window.open : function () {},
  originLatLng: [],
  rightHeaderComponent: null,
  showProgramUsersInfo: false,
  intlProvider: {
    locale: 'en',
    messages: []
  },
  showReferralStatus: true
};
export default ProgramDetailsV2;